import styled from 'styled-components';

export interface IButtonProps {
  color?: 'primary' | 'secondary' | 'error';
}

export const SButton = styled.button<IButtonProps>`
  height: 50px;
  border: none;
  border-radius: 5px;
  font-size: 17.5px;
  background-color: ${({ theme, color }) => {
    if (color && color === 'secondary') {
      return theme.colors.primaryBackground;
    }
    if (color && color === 'error') {
      return theme.colors.error;
    } else {
      return theme.colors.primary;
    }
  }};
  color: ${({ theme, color }) => {
    if (color && color === 'error') {
      return 'white';
    } else {
      return theme.colors.primaryText;
    }
  }};
  border: 1px solid
    ${({ theme, color }) => {
      if (color && color === 'secondary') {
        return theme.colors.primaryText;
      } else {
        return 'transparent';
      }
    }};

  &:disabled {
    background-color: ${({ theme }) => theme.colors.tertiaryBackground};
    color: ${({ theme }) => theme.colors.quaternaryText};
    cursor: not-allowed;
  }
`;
